/**
 * @voltxampere/ui — TCRT5000 reflective optical sensor variant (Sprint 43-6, placeholder)
 *
 * PLACEHOLDER. Reflective IR LED + phototransistor pair packaged
 * together for line-following / proximity sensing. The variant
 * ships as a regular NPN phototransistor; the IR LED side and
 * reflectance modelling defer to Sprint 47+.
 *
 * Reference: Vishay TCRT5000. IR LED 950 nm + NPN photo with darlington
 * gain, peak detection range 2.5 mm.
 *
 * Engine zero-diff invariant honored — canonical `bjt-npn` engine type
 * via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const sensorTcrt5000 = {
    id: "tcrt5000",
    nameTr: "TCRT5000 (Yansıtıcı IR Optik Sensör, placeholder)",
    nameEn: "TCRT5000 (Reflective IR Optical Sensor, placeholder)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "U",
    defaultValue: "TCRT5000",
    schemaType: "bjt-npn",
    defaultParams: {
        Is: 1e-14,
        Bf: 100,
        Br: 5,
        Vaf: 60,
    },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=sensor-tcrt5000.js.map